<snelstart-ui-dialog></snelstart-ui-dialog>
<snelstart-ui-dialog-definition [(visible)]="dialogVisible"
                                [useTitleBorder]="true"
                                id="ki"
                                size="lg"
                                title="Bijwerken klantenlijst en dossiers">

    <snelstart-ui-dialog-header-content>
        <div>
            Het klantenoverzicht en de dossiers voor fiscaal, jaarrapportage en salaris worden automatisch bijgewerkt.<br/>
            Een momentje geduld a.u.b. Onderbreek dit proces niet!
        </div>
    </snelstart-ui-dialog-header-content>

    <snelstart-ui-dialog-body>

        <!-- Migration overlay -->
        @if (migratingClients) {
            <div class="migration-overlay pt-3">
                @if (progressPercent !== 100) {
                    <snelstart-ui-alert [showIcon]="true" type="info">
                        <div class="d-flex align-items-center">
                            <p class="mb-0">
                                Bezig met bijwerken klantenlijsten/-dossiers... {{ progressPercent }}% voltooid
                            </p>
                        </div>
                    </snelstart-ui-alert>
                } @else {
                    <snelstart-ui-alert [showIcon]="true" type="success">
                        <div class="d-flex align-items-center">
                            <p class="mb-0">
                        Klaar! De klantenlijst en bijbehorende dossiers zijn bijgewerkt.
                            </p>
                        </div>
                    </snelstart-ui-alert>
                }
            </div>
        }
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons class="d-flex">
        @if (progressPercent !== 100) {
            <snelstart-ui-button [disabled]="true" btn-x icon="check" id="save2" type="primary">
                Verder gaan
            </snelstart-ui-button>
        } @else {
            <snelstart-ui-button btn-x icon="check" id="save2" type="primary" (click)="dialogVisibleChange.emit(false)">
                Verder gaan
            </snelstart-ui-button>
        }
    </snelstart-ui-dialog-buttons>

</snelstart-ui-dialog-definition>
